import React from 'react';
import PanelHotel from './panel-hotel';

const Hoteles = (props) => {
  if (props.hoteles.length > 0) {
    const destinos = (props.destinos) ? props.destinos : [];
    // eslint-disable-next-line no-shadow
    const ArmarHoteles = (hoteles, destinos) => hoteles.map((elemento, indice) => {
      // eslint-disable-next-line react/no-array-index-key
      return <PanelHotel indice={indice} destino={destinos[indice]} key={indice} hotel={elemento} />;
    });
    return (
      <div className='seccion hoteles'>
        {ArmarHoteles(props.hoteles, destinos)}
      </div>
    );
  }
  return <div />;
};

export default Hoteles;
